import { render, staticRenderFns } from "./SingleSignon.vue?vue&type=template&id=9dcfdec8"
import script from "./SingleSignon.vue?vue&type=script&lang=js"
export * from "./SingleSignon.vue?vue&type=script&lang=js"
import style0 from "./SingleSignon.vue?vue&type=style&index=0&id=9dcfdec8&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dcfdec8')) {
      api.createRecord('9dcfdec8', component.options)
    } else {
      api.reload('9dcfdec8', component.options)
    }
    module.hot.accept("./SingleSignon.vue?vue&type=template&id=9dcfdec8", function () {
      api.rerender('9dcfdec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/AccountSettings/SingleSignon.vue"
export default component.exports